export default "__VITE_ASSET__BBfg$dmn__"